import { render } from "./recovery.vue?vue&type=template&id=012c14b8&scoped=true"
const script = {}

import "./recovery.vue?vue&type=style&index=0&id=012c14b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4e85b6a685c6792d169835830baf5532/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012c14b8"]])

export default __exports__